import type { ISiteInfo } from '@/interfaces/ISiteInfo';
import { GlobalConstantService } from '../services/GlobalConstantService';

export type { ISiteInfo } from '@/interfaces/ISiteInfo';

export function useSiteInfo(): ISiteInfo[] {
  return GlobalConstantService.getSiteInfo() ?? [];
}
